<template>
  <div>
    <el-input :size="size" placeholder="请选择动态表单" :value="text" readonly>
      <table class="property-field-table" cellspacing="0" cellpadding="0" slot="append">
        <tr>
          <td @click="clear">&times;</td>
          <td @click="toSelect">选择动态表单</td>
        </tr>
      </table>
    </el-input>
    <form-select-dialog ref="formSelectDialog" :dataType="dataType" :configColumn="configColumn" :configCondition="configCondition" :configOperation="configOperation" :excludeNoneTable="false" :endpoint="endpoint" :uiId="uiId" @save="onSave"></form-select-dialog>
  </div>
</template>

<script>
import FormSelectDialog from '../model/FormSelectDialog'

export default {
  name: 'form-select-button',
  components: {
    FormSelectDialog
  },
  props: {
    endpoint: { type: String, required: true },
    uiId: { type: Number, required: true },
    dataType: { type: String, required: false },
    configColumn: { type: Boolean, required: false },
    configCondition: { type: Boolean, required: false },
    configOperation: { type: Boolean, required: false },
    property: { type: Object, required: true },
    size: { type: String, required: false, default: 'mini' }
  },
  data () {
    return {
      text: ''
    }
  },
  watch: {
    'property.value': {
      handler: function (val) {
        this.text = !val ? '' : JSON.parse(val).name
      },
      immediate: true
    }
  },
  methods: {
    clear () {
      this.property.value = undefined
      this.text = ''
      this.$emit('change')
    },
    toSelect () {
      this.$refs.formSelectDialog.open(this.property.value)
    },
    onSave (dynamicForm) {
      this.property.value = JSON.stringify(dynamicForm)
      this.text = dynamicForm.name
      this.$emit('change')
    }
  }
}
</script>
